var lastScrollTop = 0;

// Polyfill IE11
if ('NodeList' in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    window.onload = function() {
        const subMenuHold = document.querySelector('.sub-menu__hold');
        const introContent = document.querySelector('.intro-content');
        if (subMenuHold && introContent) {
            introContent.classList.add('with-submenu');
        }

        scrollW();
        window.addEventListener('scroll', function() {
            scrollW();
            
            const homeSection = document.getElementById('home');
            const scrollPosition = window.scrollY;
            const viewportHeight = window.innerHeight;

            if (homeSection) {
                if (scrollPosition >= viewportHeight) {
                    homeSection.classList.add('is-fixed');
                } else {
                    homeSection.classList.remove('is-fixed');
                }
            }
        });

        //map
        if(document.querySelector('#js-expand-map')){
            document.querySelector('#js-expand-map').addEventListener('click', (e) => {
                e.preventDefault();
            })
        }
        
        const parallaxImages = document.querySelectorAll('#home figure img:not(.no-parallax), #default figure img:not(.no-parallax), .parallax');
        let ukiyoInstances = [];

        function initializeParallax() {
            if (typeof Ukiyo !== 'undefined' && parallaxImages.length > 0) {
                ukiyoInstances.forEach(instance => { if(instance.destroy) instance.destroy(); });
                ukiyoInstances = Array.from(parallaxImages).map(img => new Ukiyo(img, {
                    scale: 1.1,
                    speed: 1.7,
                    willChange: true,
                }));
            }
        }
        initializeParallax();
        window.addEventListener('resize', initializeParallax);

        function isMobile() { return window.innerWidth <= 900; }
        
        if (window.innerWidth <= 640) {
            const submenuHold = document.querySelector(".sub-menu__hold .sub-menu");
            if (submenuHold) {
                const originalUl = submenuHold.querySelector("ul");
                if (originalUl && !submenuHold.querySelector('.custom-submenu-trigger')) {
                    const activeLink = originalUl.querySelector("a.active");
                    const activeText = activeLink ? activeLink.textContent.trim() : "Select Menu";
                    const customSelectWrapper = document.createElement("div");
                    customSelectWrapper.className = "custom-submenu-select";
                    const trigger = document.createElement("div");
                    trigger.className = "custom-submenu-trigger";
                    trigger.innerHTML = `<span>${activeText}</span> <i class="arrow"></i>`;
                    originalUl.classList.add("custom-submenu-list");
                    customSelectWrapper.appendChild(trigger);
                    originalUl.parentNode.insertBefore(customSelectWrapper, originalUl);
                    customSelectWrapper.appendChild(originalUl);
                    trigger.addEventListener("click", (e) => {
                        e.stopPropagation();
                        customSelectWrapper.classList.toggle("is-open");
                    });
                    document.addEventListener("click", () => customSelectWrapper.classList.remove("is-open"));
                }
            }
        }

        (function observeHeaderChanges() {
            const header = document.getElementById("header");
            const hold = document.querySelector(".sub-menu__hold");
            if (!header || !hold) return;

            function updateSubmenuPosition() {
                if (header.classList.contains("not-image")) {
                    hold.style.position = "fixed";
                    hold.style.top = header.offsetHeight + "px";
                } else {
                    hold.style.position = ""; 
                    hold.style.top = "";
                }
            }
            updateSubmenuPosition();
            const observer = new MutationObserver(() => updateSubmenuPosition());
            observer.observe(header, { attributes: true, attributeFilter: ['class'] });
            window.addEventListener('resize', updateSubmenuPosition);
        })();

        const emailForm = document.getElementById('email-signup');
        if(emailForm){
            ['_FNAME', '_LNAME', '_email_address'].forEach(idSuffix => {
                const input = document.getElementById('email-signup' + idSuffix);
                if(input) input.addEventListener('focus', function(){ this.parentElement.classList.add('moved'); });
            });
        }

        const fields = document.getElementsByClassName('form-module__field');
        for(let i = 0; i < fields.length; i++){
            const el = fields[i].querySelector('input, select, textarea');
            if(el) {
                if(el.type !== 'checkbox' && el.type !== 'radio') {
                    el.addEventListener('focus', function(){ this.parentElement.classList.add('moved'); });
                }
            }
        }

        const menuContainer = document.getElementById('menu-container');
        if(menuContainer){
            const openBtn = document.querySelector('.js-open-menu');
            const closeBtn = document.querySelector('.js-close-menu');
            const linksMenu = document.querySelectorAll('.privary-navigation__item a, .primary-navigation__item a');

            linksMenu.forEach(link => {
                const sync = () => {
                    const match = link.className.match(/img-([^\s]+)/);
                    if (!match) return;
                    const target = match[1].replace('active', '').trim();
                    const imgsMenu = document.querySelectorAll('.menu__images img');
                    imgsMenu.forEach(img => img.classList.toggle('active', img.dataset.image === target));
                };
                link.addEventListener('mouseenter', sync);
                link.addEventListener('focus', sync);
            });

            if (window.innerWidth <= 900) {
                const menuItemsWithChildren = menuContainer.querySelectorAll('li:has(.submenu), li:has(.sub-menu)');
                let prevMenuItem;

                menuItemsWithChildren.forEach((element) => {
                    let mainLink = element.querySelector('a');
                    let linkUrl = mainLink.href;
                    let submenuWrap = element.querySelector('.submenu') || element.querySelector('.sub-menu');

                    if (submenuWrap) {
                        if (!submenuWrap.querySelector('.primary-nav-js')) {
                            const newListItem = `
                                <li class="privary-navigation__item primary-nav-js">
                                    <a tabindex="-1" aria-haspopup="false" href="${linkUrl}">Overview</a>
                                </li>`;
                            submenuWrap.insertAdjacentHTML('afterbegin', newListItem);
                        }

                        mainLink.addEventListener('click', (e) => {
                            e.preventDefault();
                            if (prevMenuItem && prevMenuItem !== submenuWrap) {
                                prevMenuItem.classList.remove('active');
                            }
                            submenuWrap.classList.toggle('active');
                            prevMenuItem = submenuWrap;
                        });
                    }
                });
            }

            const toggleMenu = (open) => {
                menuContainer.classList.toggle('show', open);
                if(openBtn) openBtn.setAttribute('aria-expanded', open);
                if(open) {
                    const first = menuContainer.querySelector('a, button');
                    if(first) setTimeout(() => first.focus(), 100);
                } else if(openBtn) {
                    openBtn.focus();
                }
            };

            if(openBtn) openBtn.addEventListener('click', () => toggleMenu(true));
            if(closeBtn) closeBtn.addEventListener('click', () => toggleMenu(false));

            if(document.querySelector('.js-burger-close')){
                document.querySelector('.js-burger-close').addEventListener('click', (e) => {
                    e.preventDefault();
                    toggleMenu(false);
                })
            }

        }   

        const customFullscreen = new LBX('.full-screen', {});
        customFullscreen.fullScreen = true;

        // pages without h1
        const targetDiv = document.getElementById('h1-uvp');

        if (!introContent && targetDiv) {
            const h1 = document.createElement('h1');
            
            h1.id = targetDiv.id;
            h1.className = targetDiv.className;
            h1.innerHTML = targetDiv.innerHTML;
            targetDiv.parentNode.replaceChild(h1, targetDiv);
        }
    };

    document.querySelectorAll('p').forEach(p => {
        if(p.innerHTML.trim() === '') p.remove();
    });

    document.querySelectorAll('.form-module-wrapper').forEach(wrapper => {
        const inner = wrapper.querySelector('.form-module');
        if(inner) inner.classList.add('animate-fade', 'top');
    });

    document.querySelectorAll('.text-modules-wrapper').forEach(wrapper => {
        const inner = wrapper.querySelector('.text-modules');
        if(inner) inner.classList.add('animate-fade', 'top');
    });

    const sitemap = document.querySelector('.global-sitemap');
    if(sitemap) sitemap.classList.add('animate-fade', 'top');

    (function layoutHeaderNav() {
        if (window.innerWidth <= 640) return;

        const nav  = document.querySelector(".privary-navigation__list");
        const logo = document.querySelector(".header__logo");
        
        if (!nav || !logo) return;

        const items = Array.prototype.slice.call(nav.children);
        const navItems = items.filter(item => item !== logo && !item.contains(logo));
        const firstGroup  = navItems.slice(0, 3);
        const secondGroup = navItems.slice(3);

        const leftWrap  = document.createElement("li");
        const rightWrap = document.createElement("li");
        leftWrap.className  = "nav-left";
        rightWrap.className = "nav-right";

        const leftUl = document.createElement("ul");
        const rightUl = document.createElement("ul");
        
        const logoWrap = document.createElement("li");
        logoWrap.className = "nav-center-logo"; 

        for (let i = 0; i < firstGroup.length; i++)  leftUl.appendChild(firstGroup[i]);
        for (let j = 0; j < secondGroup.length; j++) rightUl.appendChild(secondGroup[j]);

        leftWrap.appendChild(leftUl);
        rightWrap.appendChild(rightUl);
        logoWrap.appendChild(logo);

        nav.innerHTML = "";
        nav.appendChild(leftWrap);
        nav.appendChild(logoWrap);
        nav.appendChild(rightWrap);
    })();

})();

function scrollW() {
    const header = document.getElementById('header');
    const logoLink = document.querySelector('.js-scroll-logo');
    const logoImg = logoLink ? logoLink.querySelector('img') : null;

    if (!header) return;

    let st = window.pageYOffset || document.documentElement.scrollTop;
    const hasNotImageClass = header.classList.contains('not-image');

    if (st > 80) {
        if (st > lastScrollTop) {
            header.classList.add('down');
            header.classList.remove('up');
        } else {
            header.classList.add('up');
            header.classList.remove('down');
        }
    } else {
        header.classList.remove('up', 'down');
    }

    lastScrollTop = st <= 0 ? 0 : st;
}